export default __webpack_public_path__ + "static/Stripe-834a4249e3861dc08cec7ea9452370e5.png";